import { Component, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { map, startWith, switchMap } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import { BoxComponent, FormFieldComponent, InputComponent } from '@core/user-interface-legacy';

import { EvaluationFieldLabelComponent } from '../evaluation-field-label/evaluation-field-label.component';

@Component({
  selector: 'rt-evaluation-single-line-field',
  templateUrl: './evaluation-single-line-field.component.html',
  styleUrls: ['./evaluation-single-line-field.component.less'],
  imports: [
    ReactiveFormsModule,
    BoxComponent,
    FormFieldComponent,
    InputComponent,
    TranslatePipe,
    EvaluationFieldLabelComponent,
  ],
})
export class EvaluationSingleLineFieldComponent {
  public readonly control = input.required<FormControl<string | null>>();
  public readonly title = input<string>('');
  public readonly hint = input<string>('');
  public readonly required = input<boolean>(false);
  public readonly showValidationErrors = input<boolean>(false);

  protected value = toSignal(
    toObservable(this.control).pipe(
      switchMap(control => control.valueChanges.pipe(startWith(control.value))),
    ),
    { initialValue: null },
  );

  protected isControlInvalid = toSignal(
    toObservable(this.control).pipe(
      switchMap(control =>
        control.events.pipe(
          map(() => control.invalid),
          startWith(control.invalid),
        ),
      ),
    ),
    { initialValue: false },
  );

  protected hasError = computed(() => this.showValidationErrors() && this.isControlInvalid());
}
